import {Injectable} from "@angular/core";

import {Observable} from "rxjs";
import {Observer} from "rxjs";
import {RaVersion} from "../configuration/ra.version";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class MessageService {

    private messages:any;

    constructor(private http: HttpClient) {
    }

    public loadMessages(): Observable<boolean> {
        return Observable.create((observer: Observer<boolean>) => {
            this.http.get("resources/messages.json" + RaVersion.full).subscribe( data => {
                this.messages = data;
                observer.next(true);
            });
        });
    }

    public getMessage(message: string): any {
        return this.messages[message];
    }

    public splitMessages(messages: string): Array<string> {
        return messages.split(", ");
    }

}
